import React from 'react';
import { currency } from '@utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { Card, CardContent, Divider, Box } from '@mui/material';
import { Icons } from '@components';
import {
  mdiCalendarMonth,
  mdiAccount,
  mdiDomain,
  mdiTrendingUp,
  mdiTrendingDown,
} from '@mdi/js';

import { coresPrincipais } from '../../../utils/colors';
import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css';

export const Carousel = ({ contribuicoes, loading }) => {
  if (loading) {
    return <div className="p-3 text-center">Carregando...</div>;
  }

  if (!contribuicoes || contribuicoes.length === 0) {
    return null;
  }

  return (
    <div className="contribuicoes-carousel-container w-100">
      <Swiper
        modules={[Pagination]}
        spaceBetween={15}
        slidesPerView="auto"
        pagination={{
          clickable: true,
        }}
        className="contribuicoes-swiper"
      >
        {contribuicoes.map((item, index) => {
          const totalVoce = Number(item.voce) + Number(item.adicional);
          const isRentPositive = Number(item.rentabilidadeValor) >= 0;

          const rentTextColor = isRentPositive
            ? coresPrincipais.positive_currency
            : coresPrincipais.negative_currency;

          return (
            <SwiperSlide key={item.id ?? index} style={{ width: '280px' }}>
              <Card
                variant="outlined"
                sx={{
                  borderRadius: '12px',
                  height: '100%',
                  borderColor: '#eaeaea',
                  boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    px: 2,
                    pt: 2,
                    pb: 0,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Icons
                    path={mdiCalendarMonth}
                    size={1.1}
                    color="var(--primary-color)"
                    style={{ marginRight: '8px' }}
                  />
                  <h5 className="mb-0 fw-bold">
                    {item.mes}/{item.ano}
                  </h5>
                </Box>

                <CardContent
                  sx={{ flexGrow: 1, paddingBottom: '16px !important' }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center text-muted">
                      <Icons
                        path={mdiAccount}
                        size={0.9}
                        color="#6c757d"
                        style={{ marginRight: '8px' }}
                      />
                      <span>Você</span>
                    </div>
                    <span className="fw-bold fs-6">{currency(totalVoce)}</span>
                  </div>

                  <Divider sx={{ my: 1.5 }} />

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center text-muted">
                      <Icons
                        path={mdiDomain}
                        size={0.9}
                        color="#6c757d"
                        style={{ marginRight: '8px' }}
                      />
                      <span>Empresa</span>
                    </div>
                    <span className="fw-bold fs-6">
                      {currency(item.empresa)}
                    </span>
                  </div>

                  <Divider sx={{ my: 1.5 }} />

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center text-muted">
                      <Icons
                        path={isRentPositive ? mdiTrendingUp : mdiTrendingDown}
                        size={1.1}
                        color={rentTextColor}
                        style={{ marginRight: '8px' }}
                      />
                      <span>Rentabilidade</span>
                    </div>
                    <span
                      className="fw-bold fs-6"
                      style={{ color: rentTextColor }}
                    >
                      {item.rentabilidadeValor !== undefined
                        ? currency(item.rentabilidadeValor)
                        : currency(0)}
                    </span>
                  </div>
                </CardContent>
              </Card>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
